"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("@eig-builder/core-ui/IconButton"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _modalContext = _interopRequireDefault(require("../../modal-context"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", " !important;\n\n  &.modal-header-button-transparent {\n    color: ", " !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledIconButton = (0, _styledComponents["default"])(_IconButton["default"])(_templateObject(), function (props) {
  return props.theme.palette.black.dark;
}, function (props) {
  return props.theme.palette.black.main;
});

var ModalHeaderButton = function ModalHeaderButton(props) {
  var _useContext = (0, _react.useContext)(_modalContext["default"]),
      variant = _useContext.variant;

  return _react["default"].createElement(StyledIconButton, (0, _extends2["default"])({}, (0, _omit["default"])(props, 'children'), {
    className: "modal-header-button-".concat(variant)
  }), props.children);
};

ModalHeaderButton.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  onClick: _propTypes["default"].func
};
var _default = ModalHeaderButton;
exports["default"] = _default;